var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('LoadingRow',[_vm._v(" "+_vm._s(this.rowData.message())+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }